var map = {
	"./binary.png": 1158,
	"./c.png": 6918,
	"./code.png": 6802,
	"./compress.png": 6345,
	"./cpp.png": 2254,
	"./css.png": 9060,
	"./csv.png": 2025,
	"./cube.png": 7426,
	"./doc.png": 3259,
	"./exe.png": 1485,
	"./folder.png": 2881,
	"./folder_tree.png": 9270,
	"./html.png": 3970,
	"./java.png": 2969,
	"./javascript.png": 4580,
	"./json.png": 1307,
	"./jsp.png": 6486,
	"./math.png": 1415,
	"./music.png": 7388,
	"./other.png": 9423,
	"./pdf.png": 7391,
	"./picture.png": 6007,
	"./ppt.png": 329,
	"./psd.png": 5308,
	"./python.png": 1683,
	"./sql.png": 245,
	"./torrent.png": 3299,
	"./txt.png": 2309,
	"./vector.png": 5972,
	"./video.png": 900,
	"./xls.png": 9826,
	"./xml.png": 5330
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2202;